import uuidv4 from 'uuid/v4';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import createLogger from 'vuex/dist/logger';
import state from './state';
import * as actions from './action';
import mutations from './mutation';
import * as getter from '../helper/getter';

Vue.use(Vuex);
const debug = window.XCConfig.NODE_ENV !== 'production';

let plugins = [
    createPersistedState({
        storage: window.localStorage,
    }),
];
if (debug) {
    plugins.push(createLogger());
}

export default new Vuex.Store({
    plugins: plugins,
    getters: {
        hasPermission: getter.hasPermission,
        crtProductFullPath: state => {
            if (!state.crtProduct.url) {
                // TODO 这里要给出提示
                return 'javascript:void(0)';
            }
            let url;
            if (state.crtProduct.initPath) {
                url = `${state.crtProduct.url}/?hash=${uuidv4()}/#/${state.crtProduct.initPath}`;
            } else {
                url = `${state.crtProduct.url}/?hash=${uuidv4()}`;
            }
            return url;
        },
        getWsExportNumber: state => {
            return state.ws.exportNumber;
        }
    },
    state,
    mutations,
    actions,
});
